"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ST = __importStar(require("./styled"));
var RegionElement = function (_a) {
    var _b, _c;
    var isRegionOpen = _a.isRegionOpen, region = _a.region, onRegionSelect = _a.onRegionSelect, onCitySelect = _a.onCitySelect;
    var citySelectHandler = function (city) {
        var name = city.name, domain = city.domain, provider_id = city.provider_id;
        onCitySelect({ name: name, domain: domain, provider_id: provider_id });
    };
    return (<ST.RegionElement>
            <ST.RegionTitle isOpen={isRegionOpen} onClick={function () { return onRegionSelect(region); }} data-test='title'>
                {region.name}
            </ST.RegionTitle>
            {isRegionOpen && !!((_b = region.cities) === null || _b === void 0 ? void 0 : _b.length) && (<ST.CitiesWrap isOpen={isRegionOpen}>
                    {(_c = region.cities) === null || _c === void 0 ? void 0 : _c.map(function (city, index) {
                var cityName = city.name, domain = city.domain, provider_id = city.provider_id, main = city.main;
                return (<ST.CityItem key={"".concat(domain, "_").concat(provider_id, "_").concat(index)} isMain={!!main} onClick={function () { return citySelectHandler(city); }} data-test='city-item'>
                                {cityName}
                            </ST.CityItem>);
            })}
                </ST.CitiesWrap>)}
        </ST.RegionElement>);
};
exports.default = RegionElement;
